import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";

import { deleteProductApi } from "services/product-management";

const DeleteProduct = ({
  deleteModal,
  selectedProductDetail,
  fetchProductList,
  closeModel,
}) => {
  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const deleteBannerHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await deleteProductApi(selectedProductDetail._id);
      if (status || code === 200) {
        // Remove the deleted category from the list
        fetchProductList();

        closeModel();
        toastMessage(message, "success", "Delete Product");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this Product?"
        title="Delete Product"
        buttonLoader={bannerButtonLoader}
        action={deleteBannerHandler}
      />
    </>
  );
};

export default DeleteProduct;
